import type { ChartInterval } from '@/lib/chart/types';

interface TimestampedChartData {
  readonly line: ReadonlyArray<{ readonly time: number }>;
  readonly ohlcv?: ReadonlyArray<{ readonly time: number }>;
}

export interface ConnectedChartFramePolicy {
  readonly hasTimestampedData: boolean;
  readonly ready: boolean;
  readonly remember: boolean;
}

/** Authoritative Market Share keeps painted geometry outside the chart data array. */
export function resolveConnectedChartFramePolicy(args: {
  readonly interval: ChartInterval;
  readonly requestReady: boolean;
  readonly authoritativeReady: boolean;
  readonly data: Readonly<Record<number, TimestampedChartData>>;
}): ConnectedChartFramePolicy {
  const hasTimestampedData = Object.values(args.data).some(
    (series) => series.line.length > 0 || (series.ohlcv?.length ?? 0) > 0,
  );
  return {
    hasTimestampedData,
    ready: args.requestReady && (args.interval !== 'live' || hasTimestampedData),
    remember: hasTimestampedData || args.authoritativeReady,
  };
}
